var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "46px",
    viewBox: "0 0 48 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.000000, -35.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6909091,
    cy: 10.6972549,
    rx: 10.6909091,
    ry: 10.6070588
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3090909,
    cy: 10.6972549,
    rx: 10.6909091,
    ry: 10.6070588
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6909091,
    cy: 35.3027451,
    rx: 10.6909091,
    ry: 10.6070588
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3090909,
    cy: 35.3027451,
    rx: 10.6909091,
    ry: 10.6070588
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrey);
export default __webpack_public_path__ + "static/media/trey.cfc46e2bac4dd2ead69d4d1a8a552777.svg";
export { ForwardRef as ReactComponent };